import { ClientJS } from 'clientjs'
import type { Ref } from 'vue'

/*
 * onFocusOnly usage
 * div(tabindex="0" @focus="setFocused(true)" @blur="setFocused(false)")
 * Need tabindex="0" to make sure focus and blur work
 */

export const useKeyboardShortcut = ({
  opts = {},
  onFocusOnly = false,
  disabled = ref(false),
}: {
  opts: { [key: string]: () => any }
  onFocusOnly?: boolean
  disabled?: Ref<boolean>
}) => {
  // this can be non-reactive because it doesn't change
  const isMac = new ClientJS().isMac()
  const focused = ref(false)

  onMounted(() => window.addEventListener('keydown', _handleKeyDown))
  onUnmounted(() => window.removeEventListener('keydown', _handleKeyDown))

  function _handleKeyDown(e: KeyboardEvent) {
    if (disabled.value) return
    if (onFocusOnly && !focused.value) return
    if (!_isValidShortcutKey(e)) return

    e.preventDefault()
    opts[e.key]()
  }

  function _isValidShortcutKey(e: KeyboardEvent) {
    return !e.shiftKey && !e.altKey && opts[e.key] && ((isMac && e.metaKey && !e.ctrlKey) || (!isMac && e.ctrlKey && !e.metaKey))
  }

  return {
    modifierKey: isMac ? '⌘' : 'CTRL',
    focused: readonly(focused),
    setFocused: (v: boolean) => (focused.value = v),
  }
}
